import { render, staticRenderFns } from "./photo-choice.vue?vue&type=template&id=0d137427&scoped=true&lang=pug&"
import script from "./photo-choice.vue?vue&type=script&lang=js&"
export * from "./photo-choice.vue?vue&type=script&lang=js&"
import style0 from "./photo-choice.vue?vue&type=style&index=0&id=0d137427&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d137427",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d137427')) {
      api.createRecord('0d137427', component.options)
    } else {
      api.reload('0d137427', component.options)
    }
    module.hot.accept("./photo-choice.vue?vue&type=template&id=0d137427&scoped=true&lang=pug&", function () {
      api.rerender('0d137427', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/photoChoice/photo-choice.vue"
export default component.exports